export class Content{
    id:number;
    information:string;
    changedInformation:string;
    transactionId:number;
    transactionSubject:string;
    transactionUserId:number;
    transactionUserName:string;
    transactionDate:Date;
}